/* tslint:disable */
/* eslint-disable */
// These are customized versions of the auto-generated mutations.ts

import gql from "graphql-tag";
import * as APITypes from "../API";

// Account

export const createAccount = /* GraphQL */ gql`
    mutation CreateAccount(
        $input: CreateAccountInput!
        $condition: ModelAccountConditionInput
    ) {
        createAccount(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            ownerId
            name
            address
            city
            state
            postalCode
        }
    }
`;

export const updateAccount = /* GraphQL */ gql`
    mutation UpdateAccount(
        $input: UpdateAccountInput!
        $condition: ModelAccountConditionInput
    ) {
        updateAccount(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            ownerId
            name
            address
            city
            state
            postalCode
        }
    }
`;
export const deleteAccount = /* GraphQL */ gql`
    mutation DeleteAccount(
        $input: DeleteAccountInput!
        $condition: ModelAccountConditionInput
    ) {
        deleteAccount(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            ownerId
            name
            address
            city
            state
            postalCode
        }
    }
`;

// User

export const createUser = /* GraphQL */ gql`
    mutation CreateUser(
        $input: CreateUserInput!
        $condition: ModelUserConditionInput
    ) {
        createUser(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            userStatus
            userType
            startDate
            endDate
            accountId
            firstName
            lastName
            email
            phone
            emailVerified
            phoneVerified
            mfaPreference
            role
            advisorAccess
            lastAccess
            customerId
            currentModelId
            advisorModelId
            primaryModelId
            advisorPrimaryModelId
            currentPlanId
            migrateStatus
            migratedOn
            subscribedOn
            cancelledOn
            deletedOn
            deletedReason
            clientOn
            referrer
            sessionCount
        }
    }
`;

export const updateUser = /* GraphQL */ gql`
    mutation UpdateUser(
        $input: UpdateUserInput!
        $condition: ModelUserConditionInput
    ) {
        updateUser(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userStatus
            userType
            startDate
            endDate
            firstName
            lastName
            email
            phone
            emailVerified
            phoneVerified
            mfaPreference
            role
            advisorAccess
            lastAccess
            customerId
            currentModelId
            advisorModelId
            primaryModelId
            advisorPrimaryModelId
            currentPlanId
            migrateStatus
            migratedOn
            subscribedOn
            cancelledOn
            deletedOn
            deletedReason
            clientOn
            referrer
            sessionCount
        }
    }
`;
export const deleteUser = /* GraphQL */ gql`
    mutation DeleteUser(
        $input: DeleteUserInput!
        $condition: ModelUserConditionInput
    ) {
        deleteUser(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            userStatus
            userType
            startDate
            endDate
            accountId
            firstName
            lastName
            email
            phone
            emailVerified
            phoneVerified
            mfaPreference
            role
            advisorAccess
            lastAccess
            customerId
            currentModelId
            advisorModelId
            primaryModelId
            advisorPrimaryModelId
            currentPlanId
            migrateStatus
            migratedOn
            subscribedOn
            cancelledOn
            deletedOn
            deletedReason
            clientOn
            referrer
            sessionCount
        }
    }
`;

// UserSetting

export const createUserSetting = /* GraphQL */ gql`mutation CreateUserSetting(
  $input: CreateUserSettingInput!
  $condition: ModelUserSettingConditionInput
) {
  createUserSetting(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    name
    description
    settingType
    settings
  }
}
`;
export const updateUserSetting = /* GraphQL */ gql`mutation UpdateUserSetting(
  $input: UpdateUserSettingInput!
  $condition: ModelUserSettingConditionInput
) {
  updateUserSetting(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    name
    description
    settingType
    settings
  }
}
`;
export const deleteUserSetting = /* GraphQL */ gql`mutation DeleteUserSetting(
  $input: DeleteUserSettingInput!
  $condition: ModelUserSettingConditionInput
) {
  deleteUserSetting(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    name
    description
    settingType
    settings
  }
}
`;

// UserInvite

export const createUserInvite = /* GraphQL */ gql`mutation CreateUserInvite(
  $input: CreateUserInviteInput!
  $condition: ModelUserInviteConditionInput
) {
  createUserInvite(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    firstName
    lastName
    email
    role
    invitedOn
  }
}
`;

export const updateUserInvite = /* GraphQL */ gql`mutation UpdateUserInvite(
  $input: UpdateUserInviteInput!
  $condition: ModelUserInviteConditionInput
) {
  updateUserInvite(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    firstName
    lastName
    email
    role
    invitedOn
    __typename
  }
}
`;

export const deleteUserInvite = /* GraphQL */ gql`mutation DeleteUserInvite(
  $input: DeleteUserInviteInput!
  $condition: ModelUserInviteConditionInput
) {
  deleteUserInvite(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    firstName
    lastName
    email
    role
    invitedOn
    __typename
  }
}
`;

// Model

export const createModel = /* GraphQL */ gql`
    mutation CreateModel(
        $input: CreateModelInput!
        $condition: ModelModelConditionInput
    ) {
        createModel(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            updatedBy
            accountId
            userId
            name
            description
            startedAt
            advisorCreated
            clientAccess
            archived     
            settings
        }
    }
`;
export const updateModel = /* GraphQL */ gql`
    mutation UpdateModel(
        $input: UpdateModelInput!
        $condition: ModelModelConditionInput
    ) {
        updateModel(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            updatedBy
            accountId
            userId
            name
            description
            startedAt
            advisorCreated
            clientAccess
            archived
            settings
        }
    }
`;
export const deleteModel = /* GraphQL */ gql`
    mutation DeleteModel(
        $input: DeleteModelInput!
        $condition: ModelModelConditionInput
    ) {
        deleteModel(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            updatedBy
            accountId
            userId
            name
            description
            startedAt
            advisorCreated
            clientAccess
            archived
            settings
        }
    }
`;

// Snapshot

export const createSnapshot = /* GraphQL */ gql`
    mutation CreateSnapshot(
        $input: CreateSnapshotInput!
        $condition: ModelSnapshotConditionInput
    ) {
        createSnapshot(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            date
            description
            snapshotType
            archived
            details
        }
    }
`;
export const updateSnapshot = /* GraphQL */ gql`
    mutation UpdateSnapshot(
        $input: UpdateSnapshotInput!
        $condition: ModelSnapshotConditionInput
    ) {
        updateSnapshot(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            date
            description
            snapshotType
            archived
            details
        }
    }
`;
export const deleteSnapshot = /* GraphQL */ gql`
    mutation DeleteSnapshot(
        $input: DeleteSnapshotInput!
        $condition: ModelSnapshotConditionInput
    ) {
        deleteSnapshot(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            date
            description
            snapshotType
            archived
            details
        }
    }
`;

// Person

export const createPerson = /* GraphQL */ gql`
    mutation CreatePerson(
        $input: CreatePersonInput!
        $condition: ModelPersonConditionInput
    ) {
        createPerson(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            nickname
            gender
            maritalStatus
            birthDate
            hereditaryAdjust
            lifeExpectancy
            retireDate
            state
        }
    }
`;
export const updatePerson = /* GraphQL */ gql`
    mutation UpdatePerson(
        $input: UpdatePersonInput!
        $condition: ModelPersonConditionInput
    ) {
        updatePerson(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            nickname
            gender
            maritalStatus
            birthDate
            hereditaryAdjust
            lifeExpectancy
            retireDate
            state
        }
    }
`;
export const deletePerson = /* GraphQL */ gql`
    mutation DeletePerson(
        $input: DeletePersonInput!
        $condition: ModelPersonConditionInput
    ) {
        deletePerson(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            nickname
            gender
            maritalStatus
            birthDate
            hereditaryAdjust
            lifeExpectancy
            retireDate
            state
        }
    }
`;

// Asset

export const createAsset = /* GraphQL */ gql`
    mutation CreateAsset(
        $input: CreateAssetInput!
        $condition: ModelAssetConditionInput
    ) {
        createAsset(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            assetCategory
            assetType
            description
            risk
            balance
            balanceDate
            returnRate
            rateLock
            withdrawalOrder
            inheritedYear
            originalOwnerBirthYear
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            priorEoYBalance
            withdrawalsYTD
            managed
            archived
        }
    }
`;
export const updateAsset = /* GraphQL */ gql`
    mutation UpdateAsset(
        $input: UpdateAssetInput!
        $condition: ModelAssetConditionInput
    ) {
        updateAsset(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            assetCategory
            assetType
            description
            risk
            balance
            balanceDate
            returnRate
            rateLock
            withdrawalOrder
            inheritedYear
            originalOwnerBirthYear
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            priorEoYBalance
            withdrawalsYTD
            managed
            archived
        }
    }
`;
export const deleteAsset = /* GraphQL */ gql`
    mutation DeleteAsset(
        $input: DeleteAssetInput!
        $condition: ModelAssetConditionInput
    ) {
        deleteAsset(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            assetCategory
            assetType
            description
            risk
            balance
            balanceDate
            returnRate
            rateLock
            withdrawalOrder
            inheritedYear
            originalOwnerBirthYear
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            priorEoYBalance
            withdrawalsYTD
            managed
            archived
        }
    }
`;

// AssetConversion

export const createAssetConversion = /* GraphQL */ gql`
mutation CreateAssetConversion(
  $input: CreateAssetConversionInput!
  $condition: ModelAssetConversionConditionInput
) {
  createAssetConversion(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    description
    conversionType  
    srcAssetId
    dstAssetId
    year
    amount
    percent  
    sortOrder
    completedAt
    taxableAmount
    nonTaxableAmount  
    incomeType
    archived
  }
}
`;
export const updateAssetConversion = /* GraphQL */ gql`
mutation UpdateAssetConversion(
  $input: UpdateAssetConversionInput!
  $condition: ModelAssetConversionConditionInput
) {
  updateAssetConversion(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    description
    conversionType  
    srcAssetId
    dstAssetId
    year
    amount
    percent  
    sortOrder
    completedAt
    taxableAmount
    nonTaxableAmount  
    incomeType
    archived
  }
}
`;
export const deleteAssetConversion = /* GraphQL */ gql`
mutation DeleteAssetConversion(
  $input: DeleteAssetConversionInput!
  $condition: ModelAssetConversionConditionInput
) {
  deleteAssetConversion(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    description
    conversionType  
    srcAssetId
    dstAssetId
    year
    amount
    percent  
    sortOrder
    completedAt
    taxableAmount
    nonTaxableAmount  
    incomeType
    archived  
  }
}
`;

// Liability

export const createLiability = /* GraphQL */ gql`
    mutation CreateLiability(
        $input: CreateLiabilityInput!
        $condition: ModelLiabilityConditionInput
    ) {
        createLiability(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            description
            balance
            balanceDate
            start
            end
            startDate
            payoffDate
            interestRate
            ownerId
            sortOrder
            archived
        }
    }
`;
export const updateLiability = /* GraphQL */ gql`
    mutation UpdateLiability(
        $input: UpdateLiabilityInput!
        $condition: ModelLiabilityConditionInput
    ) {
        updateLiability(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            description
            balance
            balanceDate
            start
            end
            startDate
            payoffDate
            interestRate
            ownerId
            sortOrder
            archived
        }
    }
`;
export const deleteLiability = /* GraphQL */ gql`
    mutation DeleteLiability(
        $input: DeleteLiabilityInput!
        $condition: ModelLiabilityConditionInput
    ) {
        deleteLiability(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            description
            balance
            balanceDate
            start
            end
            startDate
            payoffDate
            interestRate
            ownerId
            sortOrder
            archived
        }
    }
`;

// Income

export const createIncome = /* GraphQL */ gql`
    mutation CreateIncome(
        $input: CreateIncomeInput!
        $condition: ModelIncomeConditionInput
    ) {
        createIncome(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            incomeType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            survivorPercent
            archived
        }
    }
`;
export const updateIncome = /* GraphQL */ gql`
    mutation UpdateIncome(
        $input: UpdateIncomeInput!
        $condition: ModelIncomeConditionInput
    ) {
        updateIncome(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            incomeType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            survivorPercent
            archived
        }
    }
`;
export const deleteIncome = /* GraphQL */ gql`
    mutation DeleteIncome(
        $input: DeleteIncomeInput!
        $condition: ModelIncomeConditionInput
    ) {
        deleteIncome(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            incomeType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            survivorPercent
            archived
        }
    }
`;

// Deduction

export const createDeduction = /* GraphQL */ gql`
    mutation CreateDeduction(
        $input: CreateDeductionInput!
        $condition: ModelDeductionConditionInput
    ) {
        createDeduction(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            description
            sortOrder
            assetId
            archived
        }
    }
`;
export const updateDeduction = /* GraphQL */ gql`
    mutation UpdateDeduction(
        $input: UpdateDeductionInput!
        $condition: ModelDeductionConditionInput
    ) {
        updateDeduction(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            description
            sortOrder
            assetId
            archived
        }
    }
`;
export const deleteDeduction = /* GraphQL */ gql`
    mutation DeleteDeduction(
        $input: DeleteDeductionInput!
        $condition: ModelDeductionConditionInput
    ) {
        deleteDeduction(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            description
            sortOrder
            assetId
            archived
        }
    }
`;

// Tax

export const createTax = /* GraphQL */ gql`
    mutation CreateTax(
        $input: CreateTaxInput!
        $condition: ModelTaxConditionInput
    ) {
        createTax(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            taxType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            archived
        }
    }
`;
export const updateTax = /* GraphQL */ gql`
    mutation UpdateTax(
        $input: UpdateTaxInput!
        $condition: ModelTaxConditionInput
    ) {
        updateTax(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            taxType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            archived
        }
    }
`;
export const deleteTax = /* GraphQL */ gql`
    mutation DeleteTax(
        $input: DeleteTaxInput!
        $condition: ModelTaxConditionInput
    ) {
        deleteTax(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            taxType
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            sortOrder
            ownerId
            archived
        }
    }
`;

// Expense

export const createExpense = /* GraphQL */ gql`
    mutation CreateExpense(
        $input: CreateExpenseInput!
        $condition: ModelExpenseConditionInput
    ) {
        createExpense(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            expenseCategory
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            discretionary
            assetId
            liabilityId
            sortOrder
            ownerId
            archived
        }
    }
`;
export const updateExpense = /* GraphQL */ gql`
    mutation UpdateExpense(
        $input: UpdateExpenseInput!
        $condition: ModelExpenseConditionInput
    ) {
        updateExpense(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            expenseCategory
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            discretionary
            assetId
            liabilityId
            sortOrder
            ownerId
            archived
        }
    }
`;
export const deleteExpense = /* GraphQL */ gql`
    mutation DeleteExpense(
        $input: DeleteExpenseInput!
        $condition: ModelExpenseConditionInput
    ) {
        deleteExpense(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            accountId
            userId
            modelId
            expenseCategory
            description
            amount
            amountDate
            schedule
            infLock
            annualInf
            start
            end
            startDate
            endDate
            discretionary
            assetId
            liabilityId
            sortOrder
            ownerId
            archived
        }
    }
`;

// TaxValue

export const createTaxValue = /* GraphQL */ gql`
mutation CreateTaxValue(
  $input: CreateTaxValueInput!
  $condition: ModelTaxValueConditionInput
) {
  createTaxValue(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    modelId
    year
    key
    value
    __typename
  }
}
`;

export const updateTaxValue = /* GraphQL */ gql`
mutation UpdateTaxValue(
  $input: UpdateTaxValueInput!
  $condition: ModelTaxValueConditionInput
) {
  updateTaxValue(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    modelId
    year
    key
    value
    __typename
  }
}
`;

export const deleteTaxValue = /* GraphQL */ gql`
mutation DeleteTaxValue(
  $input: DeleteTaxValueInput!
  $condition: ModelTaxValueConditionInput
) {
  deleteTaxValue(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    modelId
    year
    key
    value
    __typename
  }
}
`;

// Plan

export const createPlan = /* GraphQL */ gql`
mutation CreatePlan(
  $input: CreatePlanInput!
  $condition: ModelPlanConditionInput
) {
  createPlan(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId  
    modelId
    name  
    description
    default
    archived
    changes {
      items {
          id
          createdAt
          updatedAt
          accountId
          userId
          modelId
          planId
          changeType
          name
          description
          enabled
          details
          __typename
      }
      nextToken
    }
  }
}
`;

export const updatePlan = /* GraphQL */ gql`
mutation UpdatePlan(
  $input: UpdatePlanInput!
  $condition: ModelPlanConditionInput
) {
  updatePlan(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId  
    modelId
    name
    description
    default
    archived
    changes {
      items {
          id
          createdAt
          updatedAt
          accountId
          userId
          modelId
          planId
          changeType
          name
          description
          enabled
          details
      }
      nextToken
    }
  }
}
`;

export const deletePlan = /* GraphQL */ gql`
mutation DeletePlan(
  $input: DeletePlanInput!
  $condition: ModelPlanConditionInput
) {
  deletePlan(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId  
    modelId
    name
    description
    default
    archived
  }
}
`;

// PlanChange

export const createPlanChange = /* GraphQL */ gql`
mutation CreatePlanChange(
  $input: CreatePlanChangeInput!
  $condition: ModelPlanChangeConditionInput
) {
  createPlanChange(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    modelId
    planId
    changeType
    name
    description
    enabled
    details
  }
}
`;

export const updatePlanChange = /* GraphQL */ gql`
mutation UpdatePlanChange(
  $input: UpdatePlanChangeInput!
  $condition: ModelPlanChangeConditionInput
) {
  updatePlanChange(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId  
    modelId
    planId
    changeType
    name
    description
    enabled
    details
  }
}
`;

export const deletePlanChange = /* GraphQL */ gql`
mutation DeletePlanChange(
  $input: DeletePlanChangeInput!
  $condition: ModelPlanChangeConditionInput
) {
  deletePlanChange(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    accountId
    userId
    modelId
    planId
    changeType
    name
    description
    enabled
    details
  }
}
`;

// Review

export const createReview = /* GraphQL */ gql`mutation CreateReview(
  $input: CreateReviewInput!
  $condition: ModelReviewConditionInput
) {
  createReview(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    snapshotId
    baseSnapId  
    reviewDate
    checklist
    submittedOn
    managed
    archived
    status
  }
}`;

export const updateReview = /* GraphQL */ gql`mutation UpdateReview(
  $input: UpdateReviewInput!
  $condition: ModelReviewConditionInput
) {
  updateReview(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    snapshotId
    baseSnapId  
    reviewDate
    checklist
    submittedOn
    managed
    archived  
    status  
  }
}`;

export const deleteReview = /* GraphQL */ gql`mutation DeleteReview(
  $input: DeleteReviewInput!
  $condition: ModelReviewConditionInput
) {
  deleteReview(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    userId
    accountId
    modelId
    snapshotId
    baseSnapId  
    reviewDate
    checklist
    submittedOn
    managed
    archived  
    status  
  }
}`;

// Session

export const createSession = /* GraphQL */ gql`mutation CreateSession(
    $input: CreateSessionInput!
    $condition: ModelSessionConditionInput
) {
    createSession(input: $input, condition: $condition) {
        id
        createdAt
        updatedAt
        accountId
        userId
        sessionDate
        duration
        __typename
    }
}`;

export const updateSession = /* GraphQL */ gql`mutation UpdateSession(
    $input: UpdateSessionInput!
    $condition: ModelSessionConditionInput
) {
    updateSession(input: $input, condition: $condition) {
        id
        createdAt
        updatedAt
        accountId
        userId
        sessionDate
        duration
        __typename
    }
}`;

export const deleteSession = /* GraphQL */ gql`mutation DeleteSession(
    $input: DeleteSessionInput!
    $condition: ModelSessionConditionInput
) {
    deleteSession(input: $input, condition: $condition) {
        id
        createdAt
        updatedAt
        accountId
        userId
        sessionDate
        duration
        __typename
    }
}`;